import { WebshopResponsiveConfiguration } from '../../configuration/webshop-responsive.configuration';
import { CssDisplayMode } from '../CSSDefinitions.enum';
import { WebshopAttribute } from '../entity/webshop-attribute.enum';

/**
 * DOM utilities class
 */
export class DOMUtil {

    public static getInjectedConfigurationScript(documentRef: Document, scriptName: string): HTMLScriptElement|void {
        const scriptElementList = documentRef.querySelectorAll('script');
        let scriptElement: HTMLScriptElement | undefined;

        if (!scriptElementList) {
            console.error(`No script elements found in ${documentRef.documentURI}`);
            return undefined;
        }

        for (let i = 0; i < scriptElementList.length; i++) {
            const element = scriptElementList[i];

            if (element.hasAttribute('src') &&
                element.getAttribute('src')!.indexOf(scriptName) > -1) {
                scriptElement = element;
            }
        }

        if (scriptElement === undefined) {
            console.error(`No script element with ${scriptName} found in ${documentRef.documentURI}`);
        }

        return scriptElement;
    }

    public static getWebshopResponsiveConfig(documentRef: Document): WebshopResponsiveConfiguration | void {
        const scriptElement: HTMLScriptElement | void = DOMUtil.getInjectedConfigurationScript(documentRef, 'main.js');
        const config: WebshopResponsiveConfiguration = {
            poolId: null,
            notificationLimit: null,
        };

        if (scriptElement === undefined) {
            console.error(`No webshop responsive main.js script element found in ${documentRef.documentURI}`);
            return undefined;
        }

        const poolId = (scriptElement as HTMLScriptElement).getAttribute('data-pool-id');
        const notificationLimit = (scriptElement as HTMLScriptElement).getAttribute('data-notification-limit');

        if (!poolId) {
            throw new Error(`main.js does not hold pool-id attribute`);
        }
        config.poolId = parseInt(poolId, 10);

        if (!notificationLimit) {
            throw new Error(`main.js does not hold notification-limit attribute`);
        }
        config.notificationLimit = parseInt(notificationLimit, 10);

        return config;
    }

    /**
     * DisplayMode query method
     * Takes CssDisplayMode enum value as parameter
     */
    public static isWindowInDisplayMode(mode: CssDisplayMode): boolean {
        return window.matchMedia(`(display-mode: ${mode}`).matches;
    }

    public static getWebshopStaticPathFrom(document: Document): string {
        const staticAttr = document.body.getAttribute(WebshopAttribute.Static);

        return staticAttr ?? '';
    }

    public static registerVisibilityChangeHandler(
        handleIntersectionFn: (entries: IntersectionObserverEntry[]) => void,
    ) {
        const intersectionOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0.5,
        };
    
        const observer = new IntersectionObserver(handleIntersectionFn, intersectionOptions);

        return observer;
    }
}


